"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateContactId = void 0;

var _cryptoBrowserify = _interopRequireDefault(require("crypto-browserify"));

/**
 *
 * @param firstName
 * @param lastName
 * @param user
 * @param phoneNums
 * @return {*}
 */
var generateContactId = function generateContactId(_ref) {
  var _ref$firstName = _ref.firstName,
      firstName = _ref$firstName === void 0 ? null : _ref$firstName,
      _ref$lastName = _ref.lastName,
      lastName = _ref$lastName === void 0 ? null : _ref$lastName,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? null : _ref$user;
  var arr = [];

  if (firstName) {
    // eslint-disable-next-line no-param-reassign
    firstName = firstName.toLowerCase();
    arr.push(firstName);
  }

  if (lastName) {
    // eslint-disable-next-line no-param-reassign
    lastName = lastName.toLowerCase();
    arr.push(lastName);
  }

  if (user) {
    arr.push(user);
  }

  var merged = arr.join('');
  return _cryptoBrowserify.default.createHash('md5').update(merged).digest('hex');
};

exports.generateContactId = generateContactId;